import React from "react";
import { useDropzone } from "react-dropzone";
import { Message, Ref } from "semantic-ui-react";
import { toast } from "components/Toast/Toast";
import { useTranslation } from "react-i18next";

const handleFileRejections = (rejections) => {
  rejections.forEach((rejection) => {
    rejection.errors.forEach((error) => {
      const errorMessage = error.message;
      return toast(error.type || "error", errorMessage);
    });
  });
};

const MAX_FILE_SIZE = 400 * 1024 * 1024; // 400MB
const PDF_ERROR_SIZE = 1024 * 1024 * 1024; // 1GB

const FileInput = (props) => {
  const { onChange, accept, multiple = true } = props;
  const { t } = useTranslation("common");

  const fileValidator = (file) => {
    const fileExtension = file.path.substring(file.path.lastIndexOf(".") + 1);

    if (fileExtension === "m4v") {
      return {
        code: "invalid-file-extension",
        type: "error",
        message: t("delivery_form_not_valid_extension", { fileExtension }),
      };
    }

    if (file.type === "application/pdf") {
      if (file.size > PDF_ERROR_SIZE) {
        return {
          code: "file-too-large-pdf-error",
          type: "error",
          message: t("delivery_form_file_too_large_pdf_error"),
        };
      } else if (file.size > MAX_FILE_SIZE) {
        toast("warning", t("delivery_form_file_large_pdf_warning"));
        return null;
      }
    } else if (file.size > MAX_FILE_SIZE) {
      return {
        code: "file-too-large",
        type: "error",
        message: t("delivery_form_file_too_large"),
      };
    }

    return null;
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted: onChange,
    onDropRejected: handleFileRejections,
    accept,
    multiple,
    validator: fileValidator,
  });

  const { ref, ...rootProps } = getRootProps();

  return (
    <Ref innerRef={ref}>
      <Message
        icon="image"
        header={isDragActive ? t("drop_files") : t("drag_drop_select")}
        className={"file-input" + (isDragActive ? " dragging" : "")}
        content={<input data-test="asset_file_input" {...getInputProps()} />}
        {...rootProps}
      />
    </Ref>
  );
};

export default FileInput;
